import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EventHero = ({ event }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % event?.images?.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + event?.images?.length) % event?.images?.length);
  };

  return (
    <div className="relative h-96 md:h-[500px] overflow-hidden rounded-xl bg-muted">
      {/* Image Gallery */}
      <div className="relative w-full h-full">
        <Image
          src={event?.images?.[currentImageIndex]}
          alt={event?.title}
          className="w-full h-full object-cover"
        />
        
        {/* Image Navigation */}
        {event?.images?.length > 1 && (
          <>
            <Button
              variant="ghost"
              size="icon"
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white hover:bg-black/70 w-10 h-10"
              onClick={prevImage}
            >
              <Icon name="ChevronLeft" size={20} />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white hover:bg-black/70 w-10 h-10"
              onClick={nextImage}
            >
              <Icon name="ChevronRight" size={20} />
            </Button>
          </>
        )}

        {/* Image Indicators */}
        {event?.images?.length > 1 && (
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {event?.images?.map((_, index) => (
              <button
                key={index}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentImageIndex ? 'bg-white' : 'bg-white/50'
                }`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        )}

        {/* Overlay Content */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
          <div className="flex items-center space-x-2 mb-2">
            <span className="px-3 py-1 bg-primary rounded-full text-xs font-medium">
              {event?.category}
            </span>
            {event?.featured && (
              <span className="px-3 py-1 bg-warning rounded-full text-xs font-medium text-black">
                Featured
              </span>
            )}
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-2">{event?.title}</h1>
          <div className="flex items-center space-x-4 text-sm opacity-90">
            <div className="flex items-center space-x-1">
              <Icon name="Calendar" size={16} />
              <span>{event?.date}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Clock" size={16} />
              <span>{event?.time}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="MapPin" size={16} />
              <span>{event?.venue?.name}</span>
            </div>
          </div>
        </div>
      </div>
      {/* Share Button */}
      <div className="absolute top-4 right-4">
        <Button
          variant="ghost"
          size="icon"
          className="bg-black/50 text-white hover:bg-black/70 w-10 h-10"
        >
          <Icon name="Share2" size={18} />
        </Button>
      </div>
    </div>
  );
};

export default EventHero;